import { render, staticRenderFns } from "./StrategieBagagePoids.vue?vue&type=template&id=b7a518ea&scoped=true"
import script from "./StrategieBagagePoids.vue?vue&type=script&lang=js"
export * from "./StrategieBagagePoids.vue?vue&type=script&lang=js"
import style0 from "./StrategieBagagePoids.vue?vue&type=style&index=0&id=b7a518ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a518ea",
  null
  
)

export default component.exports